module.exports = __webpack_public_path__ + "img/H-625.2b29902a.png";